export function ctor(FormData) {
  return function createFileFormData(key, file) {
    const formData = new FormData();
    formData.append(key, file);
    return formData;
  };
}

const createFileFormData = ctor(window.FormData);

export default createFileFormData;
